<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "LivePublishPlanItem",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'planId',
                        placeholder: '计划ID',
                        type: 'input'
                    },
                    {
                        name: 'groupId',
                        placeholder: '计划组ID',
                        type: 'input'
                    },
                    {
                        name: 'userId',
                        placeholder: '用户ID',
                        type: 'input'
                    },
                    {
                        name: 'accountId',
                        placeholder: '账号ID',
                        type: 'input'
                    },
                    {
                        name: 'enabled',
                        placeholder: '状态',
                        type: 'select',
                        selectValue: [{key:true, value:'启用'},{key:false, value:'禁用'}]
                    },
                    {
                        name: 'lastStatus',
                        placeholder: '最后状态',
                        type: 'select',
                        selectValue: [{key:'success', value:'success'},{key:'failed', value:'failed'},{key:'skipped', value:'skipped'},{key:'running', value:'running'}]
                    }
                ],
                permission:{
                    add: 'livePublishPlanItem:add',
                    update: 'livePublishPlanItem:update',
                    delete: 'livePublishPlanItem:delete',
                    deleteBatch: 'livePublishPlanItem:deleteBatch'
                },
                url: {
                    get: '/livePublish/planItem/listByCondition',
                    add: '/livePublish/planItem/add',
                    update: '/livePublish/planItem/update',
                    delete: '/livePublish/planItem/delete/',
                    delete_batch: '/livePublish/planItem/deleteBatch'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                }, {
                    field: 'planId',
                    label: '计划ID',
                    show: true,
                    width: '',
                }, {
                    field: 'groupId',
                    label: '计划组ID',
                    show: true,
                    width: '',
                }, {
                    field: 'userId',
                    label: '用户ID',
                    show: true,
                    width: '',
                }, {
                    field: 'accountId',
                    label: '账号ID',
                    show: true,
                    width: '',
                }, {
                    field: 'accountName',
                    label: '账号名称',
                    show: true,
                    width: '',
                }, {
                    field: 'enabled',
                    label: '状态',
                    show: true,
                    width: '80',
                }, {
                    field: 'nextRunAt',
                    label: '下次运行时间',
                    show: true,
                    width: '',
                }, {
                    field: 'runCount',
                    label: '运行次数',
                    show: true,
                    width: '100',
                }, {
                    field: 'lastRunAt',
                    label: '上次运行时间',
                    show: true,
                    width: '',
                }, {
                    field: 'lastStatus',
                    label: '最后状态',
                    show: true,
                    width: '100',
                }],
                operate: [
                    { name: 'edit', label: '编辑', type: 'text' },
                    { name: 'delete', label: '删除', type: 'text' }
                ],
                formFields: {
                    addTitle: '添加单账号计划',
                    updateTitle: '修改单账号计划',
                    model: [
                        { label: '计划ID', name: 'planId', type: 'input', required: true, placeholder: '请输入计划ID' },
                        { label: '计划组ID', name: 'groupId', type: 'input', required: true, placeholder: '请输入计划组ID' },
                        { label: '用户ID', name: 'userId', type: 'input', required: true, placeholder: '请输入用户ID' },
                        { label: '账号ID', name: 'accountId', type: 'input', required: true, placeholder: '请输入账号ID' },
                        { label: '账号名称', name: 'accountName', type: 'input', required: false, placeholder: '请输入账号名称' },
                        { label: '状态', name: 'enabled', type: 'switch', required: false, placeholder: '' },
                        { label: '运行次数', name: 'runCount', type: 'number', required: false, placeholder: '请输入运行次数' },
                        { label: '最后状态', name: 'lastStatus', type: 'select', required: false, placeholder: '请选择最后状态', selectValue: [{key:'success', value:'success'},{key:'failed', value:'failed'},{key:'skipped', value:'skipped'},{key:'running', value:'running'}] }
                    ]
                }
            }
        }
    }
</script>

<style scoped>

</style>
